'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `MediaOverlay` component is just a very simple wrapper that adds the
 * `.md-media-overlay` class name to a div. The overlay will be positioned
 * at the bottom of the `Media` by default.
 */
var MediaOverlay = function (_PureComponent) {
  _inherits(MediaOverlay, _PureComponent);

  function MediaOverlay() {
    _classCallCheck(this, MediaOverlay);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  MediaOverlay.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        Component = _props.component,
        props = _objectWithoutProperties(_props, ['className', 'component']);

    return _react2.default.createElement(Component, _extends({ className: (0, _classnames2.default)('md-media-overlay', className) }, props));
  };

  return MediaOverlay;
}(_react.PureComponent);

MediaOverlay.propTypes = {
  /**
   * An optional style to apply to the overlay.
   */
  style: _propTypes2.default.object,

  /**
   * An optional className to apply to the overlay.
   */
  className: _propTypes2.default.string,

  /**
   * Any children to display in the overlay. This is _normally_ a `CardTitle` component
   * or some buttons.
   */
  children: _propTypes2.default.node,

  /**
   * The component to be rendered as.
   */
  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
};
MediaOverlay.defaultProps = {
  component: 'div'
};
exports.default = MediaOverlay;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Media/MediaOverlay.js
// module id = 121
// module chunks = 168707334958949